module.exports = __webpack_public_path__ + "media/banners/paliwo-baner-4a16a484.svg";